import { useEffect, useState } from "react";
import { useGetRegistrationsMutation } from "../../store/services/hiveUS";
import CustomDropdown from "../../components/CustomSelect";
import { useNavigate } from "react-router-dom";

const Blogs = () => {
  const [getRegistrations, { data, isSuccess }] = useGetRegistrationsMutation();

  useEffect(() => {
    getRegistrations("");
  }, []);

  return (
    <main className="w-full bg-white flex-col flex p-10">
      <div className="filters w-full relative my-2">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold">US Registrations</h1>
        </div>
      </div>
      <table className="border-collapse rounded-xl overflow-hidden">
        <tbody>
          {/* <th> */}
          <tr className="bg-black divide-x text-white  border ">
            <th className="py-2">Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Number Of Bundles</th>
            <th>State</th>
            <th>City</th>
            <th>Going To Use HIVE At:</th>
            <th>Registered At:</th>
          </tr>
          {/* </th> */}
          {data &&
            data.length > 0 &&
            data.map((val) => {
              return (
                <tr key={val._id} className="text-center border-t border-gray-200 divide-x ">
                  <td className="py-1">{val.name}</td>
                  <td>{val.email}</td>
                  <td>{val.phone}</td>
                  <td>{val.numberOfBundles}</td>
                  <td>{val.state}</td>
                  <td>{val.city}</td>
                  <td>{val.usingWhere}</td>
                  <td>{val.saved_at}</td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </main>
  );
};

export default Blogs;
